<template>
  <v-dialog
    v-model="isDialogVisible"
    persistent
    width="900"
    scrollable
  >
    <v-card>
      <div class="d-flex pa-6 pb-0">
        <div>
          <img
            src="/images/logo-nero.png"
            width="70"
          >
        </div>
        <div
          class="ml-auto cursor-pointer"
          @click="$emit('turnoff')"
        >
          <svg
            version="1.1"
            x="0px"
            y="0px"
            width="20"
            height="20"
            viewBox="0 0 219.57 220.6"
            style="enable-background:new 0 0 219.57 220.6;"
            xml:space="preserve"
          >
            <path
              fill="black"
              d="M213.72,9.06L213.72,9.06c3.12,3.12,3.12,8.19,0,11.31L17.85,216.24c-3.12,3.12-8.19,3.12-11.31,0l0,0c-3.12-3.12-3.12-8.19,0-11.31L202.4,9.06C205.53,5.93,210.59,5.93,213.72,9.06z"
            />
            <path
              fill="black"
              d="M213.72,215.79L213.72,215.79c-3.12,3.12-8.19,3.12-11.31,0L6.54,19.92c-3.12-3.12-3.12-8.19,0-11.31l0,0c3.12-3.12,8.19-3.12,11.31,0l195.87,195.87C216.84,207.6,216.84,212.67,213.72,215.79z"
            />
          </svg>
        </div>
      </div>

      <div class="ghd-text-black ghd-ITCAvant text-uppercase text-black px-6 pt-4 text-large">
        Prova di acquisto
      </div>

      <v-card-text class="proof-of-purchase-dialog px-6 pt-4 pb-6 text-black ghd-helveticanew">
        <section
          class="pop-section"
          :class="{ highlighted: isHighlighted('amazon') }"
        >
          <h3 class="ghd-ITCAvant text-uppercase text-black section-title">
            Amazon
          </h3>
          <p class="mb-0">
            Per gli acquisti effettuati su Amazon, la sola conferma d'ordine non è
            sufficiente. È necessario scaricare e allegare la <strong>fattura di
              acquisto</strong> relativa al prodotto.
          </p>
        </section>

        <section
          class="pop-section"
          :class="{ highlighted: isHighlighted('online') }"
        >
          <h3 class="ghd-ITCAvant text-uppercase text-black section-title">
            Sito web ghd e rivenditori online autorizzati
          </h3>
          <p>
            Per gli acquisti effettuati sul nostro sito web o presso i nostri
            rivenditori online autorizzati, è necessario allegare la
            <strong>conferma d'ordine</strong>.
          </p>
          <p class="mb-1">
            La conferma d'ordine deve riportare chiaramente:
          </p>
          <ul>
            <li>il prodotto acquistato;</li>
            <li>la data di acquisto;</li>
            <li>il nome del rivenditore.</li>
          </ul>
        </section>

        <section
          class="pop-section"
          :class="{ highlighted: isHighlighted('fisico') }"
        >
          <h3 class="ghd-ITCAvant text-uppercase text-black section-title">
            Saloni autorizzati e negozi fisici autorizzati
          </h3>
          <p>
            Per gli acquisti effettuati presso un salone autorizzato o un negozio
            fisico autorizzato, è necessario allegare lo <strong>scontrino di
              acquisto</strong>.
          </p>
          <p class="mb-1">
            Anche lo scontrino deve riportare correttamente:
          </p>
          <ul>
            <li>il prodotto acquistato;</li>
            <li>la data di acquisto;</li>
            <li>il nome del rivenditore.</li>
          </ul>
        </section>

        <p class="mb-0 font-italic">
          La documentazione deve essere completa e leggibile e contenere tutte le
          informazioni necessarie per poter verificare l'acquisto.
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref } from '@vue/composition-api'

export default {
  props: {
    // sezione da evidenziare: 'amazon' | 'online' | 'fisico' oppure un array di chiavi
    highlight: {
      type: [String, Array],
      default: null,
    },
  },
  setup(props) {
    const isDialogVisible = ref(true)

    const isHighlighted = key => {
      if (!props.highlight) return false

      return Array.isArray(props.highlight)
        ? props.highlight.includes(key)
        : props.highlight === key
    }

    return { isDialogVisible, isHighlighted }
  },
}
</script>

<style scoped>
.proof-of-purchase-dialog {
  font-size: 0.95rem;
  line-height: 1.5;
}

.pop-section {
  margin-bottom: 1.5rem;
  padding: 0.75rem 1rem;
  border-left: 3px solid transparent;
  border-radius: 4px;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.pop-section.highlighted {
  background-color: #f4f4f4;
  border-left-color: #000;
}

.proof-of-purchase-dialog .section-title {
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.proof-of-purchase-dialog ul {
  margin: 0;
  padding-left: 1.25rem;
}

.proof-of-purchase-dialog li {
  margin-bottom: 0.25rem;
}

@media (max-width: 600px) {
  .proof-of-purchase-dialog {
    font-size: 0.9rem;
  }

  .pop-section {
    padding: 0.5rem 0.75rem;
    margin-bottom: 1rem;
  }
}
</style>
